<template>
  <p class="c-title-large">
    <slot />
  </p>
</template>

<style lang="scss" scoped>
.c-title-large {
  @include text__title--l;

  @include sp {
    @include text__title--m;
  }
}
</style>
